module.exports = __webpack_public_path__ + "static/media/logopaticka.2ec5b3ed.svg";